// extracted by mini-css-extract-plugin
export default {"text-editor":"text-editor__1IT96"};